var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 18"}},_vm.$listeners),[_c('path',{attrs:{"stroke":"#FFF","d":"M3.515.515l16.97 16.97m0-16.97l-16.97 16.97","stroke-width":"1.5","fill":"none","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }